import apiClient, { apiClientV1 } from './apiClient';

export default {
  getUserSettings: () => apiClientV1.get('/user/settings'),
  updateUser: (params) => apiClientV1.put('/user', { ...params }),
  setActiveUserRole: (params) => apiClientV1.patch('/user/active-role', { ...params }),
  updatePassword: (params) => apiClientV1.put('/user/update-password', { ...params }),
  setResizedPhoto: (params) => apiClientV1.put('/user/set-resized-photo', { ...params }),
  /**
   * Notifications
   */
  getNotifications: () => apiClientV1.get('/user/notification'),
  updateNotification: (params) => apiClientV1.put('/user/notification', { ...params }),
  getNotificationsList: (params) => apiClientV1.get('/user/notification-list', { params }),
  readNotifications: (notificationIds) => apiClientV1.put('/user/notifications/read', { notificationIds }),
  getUnreadNotificationsCount: () => apiClientV1.get('/user/unread-notifications-count'),
  /**
   * Attachments
   */
  getAttachments: (params) => apiClientV1.get('/user/attachments', { params }),
  updateAttachment: (attachmentId, params) => apiClientV1.put(`user/attachments/${attachmentId}`, { ...params }),
  deleteAttachment: (id) => apiClientV1.delete(`/user/attachments/${id}`),
  createAttachment: (params) => apiClientV1.post('/user/attachments', { ...params }),
  /**
   * Branding
   */
  getBrandingHeader: (params) => apiClientV1.get('/user/branding-header', { params }),
  getUserBrandingSettings: (params) => apiClientV1.get('/user/branding-settings', { params }),
  /**
   * User Logo
   */
  getUserLogos: (params) => apiClientV1.get('/user/logos', { params }),
  saveUserLogo: (params) => apiClientV1.post('/user/logo', { ...params }),
  deleteUserLogo: (logoId) => apiClientV1.delete(`/user/logo/${logoId}`),
  activateUserLogo: (params) => apiClientV1.put('/user/logo/activate', { ...params }),
  deactivateUserLogo: (params) => apiClientV1.put('/user/logo/deactivate', { ...params }),
  updateCompanyLogo: (companyId, params) => apiClientV1.patch(`/user/companies/${companyId}/logos`, { ...params }),
  /**
   * Music
   */
  getFavoriteMusic: () => apiClientV1.get('user/music/favorites'),
  addMusicToFavorite: (id) => apiClientV1.post(`user/music/${id}/favorites`),
  removeMusicFromFavorite: (id) => apiClientV1.delete(`user/music/${id}/favorites`),
  /**
   * Map Pins
   */
  getMapCategories: () => apiClientV1.get('/user/map-categories'),
  getUserPins: (params) => apiClient.get('/user/pins', { params }),
  deletePin: (pinId) => apiClient.delete(`/user/pins/${pinId}`),
  putPins: (params) => apiClient.put('/user/pins', { ...params }),
  /**
   * User Property
   */
  getProperties: (params) => apiClientV1.get('/user/properties', { params }),
  moveVideoToProperty: (videoId, params) => apiClientV1.patch(`/user/videos/${videoId}/move-to-property`, { ...params }),
  copyVideoToProperties: (videoId, params) => apiClientV1.post(`/user/videos/${videoId}/copy-to-property`, { ...params }),
  updateActiveProperty: (params) => apiClientV1.patch('/user/active-property', { ...params }),
  checkPropertyAvailability: (id, params) => apiClientV1.get(`/user/${id}/check-property-availability`, { params }),
  /**
   * Settings
   */
  updateCompanySettings: (companyId, params) => apiClientV1.patch(`/user/company/${companyId}/settings`, { ...params }),
  getUserIntegrationSettings: (params) => apiClientV1.get('/user/integrations/integration-settings', { params }),
  updateSecondaryEmails: (params) => apiClientV1.put('/user/set-additional-emails', { ...params }),
  getEmailPreview: (params) => apiClientV1.get('/user/email/preview', { params, responseType: 'blob' }),
  saveUserSettings: (params) => apiClientV1.put('/user/settings', { ...params }),
  saveEmailCta: (params) => apiClientV1.patch('/user/save-email-cta', { ...params }),
  /**
   * Activity
   */
  getActivityFeed: () => apiClientV1.get('/user/prospects/activity-feed')
};
